import React from 'react';
import Select from '../../../components/ui/Select';

const GrowthRiskForm = ({ formData, onUpdate }) => {
  const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
  ];

  const riskLevelOptions = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Planning New Product/Service?"
          placeholder="Select option"
          options={yesNoOptions}
          value={formData?.planningNewProduct || ''}
          onChange={(value) => onUpdate({ planningNewProduct: value })}
          required
        />

        <Select
          label="Planning Price Increase?"
          placeholder="Select option"
          options={yesNoOptions}
          value={formData?.planningPriceIncrease || ''}
          onChange={(value) => onUpdate({ planningPriceIncrease: value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Expansion to New Region?"
          placeholder="Select option"
          options={yesNoOptions}
          value={formData?.expansionToNewRegion || ''}
          onChange={(value) => onUpdate({ expansionToNewRegion: value })}
          required
        />

        <Select
          label="Hiring in Next 12 Months?"
          placeholder="Select option"
          options={yesNoOptions}
          value={formData?.hiringPlans || ''}
          onChange={(value) => onUpdate({ hiringPlans: value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Regulatory Risk?"
          placeholder="Select risk level"
          options={riskLevelOptions}
          value={formData?.regulatoryRisk || ''}
          onChange={(value) => onUpdate({ regulatoryRisk: value })}
          required
        />

        <Select
          label="Competitor Pressure?"
          placeholder="Select pressure level"
          options={riskLevelOptions}
          value={formData?.competitorPressure || ''}
          onChange={(value) => onUpdate({ competitorPressure: value })}
          required
        />
      </div>
    </div>
  );
};

export default GrowthRiskForm;